import React, { useEffect, useState } from 'react'
import { HabilitationAccordion } from '../access/HabilitationAccordion'
import { INSTALLATION } from '../../../constants/ApplicationHabilitationConstants'
import i18n from '../../../../../../simple-react-i18n'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import InstallationAction from '../../../../../../installation/actions/InstallationAction'
import DtoInstallation from '../../../../../../installation/dto/installation/DtoInstallation'

const HabilitationInstallation = ({}) => {
    const dispatch = useDispatch()
    const {
        installations,
    } = useSelector(store => ({
        installations: store.InstallationReducer.installations,
    }), shallowEqual)

    const [isLoaded, setIsLoaded] = useState(false)

    useEffect(() => {
        if (installations.length === 0) {
            dispatch(InstallationAction.fetchInstallations())
                .then(() => setIsLoaded(true))
        } else {
            setIsLoaded(true)
        }
    }, [dispatch])

    return (
        <HabilitationAccordion
            stationType={INSTALLATION}
            title={i18n.installation}
            stations={installations}
            isLoaded={isLoaded}
            noNetworkDisplay
        />
    )
}

HabilitationInstallation.propTypes = {
    installations: PropTypes.arrayOf(PropTypes.instanceOf(DtoInstallation)),
    fetchInstallations: PropTypes.func,
}

export default HabilitationInstallation